import { whatsappIntegrationDisplayLabel } from "@/lib/whatsapp-integration-label";

type IntegrationRow = {
  id: string;
  provider: string;
  instance_identifier?: string | null;
  config?: Record<string, unknown> | null;
};

function cfgString(config: IntegrationRow["config"], key: string): string {
  const v = config?.[key];
  return typeof v === "string" ? v : "";
}

export function integrationDisconnectLabel(integration: IntegrationRow): string {
  if (integration.provider === "whatsapp_evolution" || integration.provider === "whatsapp_uazapi") {
    return whatsappIntegrationDisplayLabel(integration);
  }
  if (integration.provider === "instagram") {
    const user = cfgString(integration.config, "instagram_username");
    return user ? `@${user}` : cfgString(integration.config, "page_name") || "Instagram";
  }
  if (integration.provider === "messenger") {
    return cfgString(integration.config, "page_name") || "Messenger";
  }
  if (integration.provider === "whatsapp_cloud") {
    const display =
      cfgString(integration.config, "display_phone_number") ||
      cfgString(integration.config, "verified_name");
    return display || "WhatsApp API Oficial";
  }
  return integration.instance_identifier || "Integração";
}

export function integrationDisconnectDetail(integration: IntegrationRow): string | undefined {
  if (integration.provider === "whatsapp_evolution" || integration.provider === "whatsapp_uazapi") {
    const phone =
      cfgString(integration.config, "phone_number") ||
      cfgString(integration.config, "phone") ||
      cfgString(integration.config, "number");
    return phone || undefined;
  }
  if (integration.provider === "instagram") {
    return cfgString(integration.config, "instagram_name") || undefined;
  }
  if (integration.provider === "whatsapp_cloud") {
    const waba = cfgString(integration.config, "waba_id");
    return waba ? `WABA ${waba}` : undefined;
  }
  return undefined;
}
